import { haversineKm } from "./mobileScreenUtils";

const HISTORY_POINTS = 15;
const SAMPLE_INTERVAL_MS = 10000;
const UPDATE_INTERVAL_MS = 30000;
const DEFAULT_SPEED_KPH = 20;
const MAX_TOTAL_INCREASE_MINUTES = 2;

export const appendMovementPoint = (history, live) => {
  const timestamp = Date.parse(live?.receivedAt);
  if (!Number.isFinite(timestamp) || haversineKm(live, live) === null) return history;
  const last = history[history.length - 1];
  if (last && timestamp - last.timestamp < SAMPLE_INTERVAL_MS) return history;
  // Discard old history after a prolonged loss of updates.
  const recent = last && timestamp - last.timestamp > 300000 ? [] : history;
  return [...recent, { latitude: Number(live.latitude), longitude: Number(live.longitude), timestamp }]
    .slice(-HISTORY_POINTS);
};

export const movementSpeed = (history) => {
  let distanceKm = 0;
  let seconds = 0;
  for (let i = 1; i < history.length; i++) {
    const elapsed = (history[i].timestamp - history[i - 1].timestamp) / 1000;
    const distance = haversineKm(history[i - 1], history[i]);
    if (elapsed < 10 || distance === null) continue;
    const speed = distance / (elapsed / 3600);
    // Ignore GPS jitter, stationary samples, and implausible jumps.
    if (distance < 0.01 || speed < 1 || speed > 100) continue;
    distanceKm += distance;
    seconds += elapsed;
  }
  return seconds > 0 ? distanceKm / (seconds / 3600) : DEFAULT_SPEED_KPH;
};

export const stableETA = (distanceKm, history, previous, now) => {
  if (!Number.isFinite(distanceKm) || distanceKm <= 0) {
    return { minutes: 0, smoothedETA: 0, etaSeconds: 0, updatedAt: now };
  }
  if (previous && now - previous.updatedAt < UPDATE_INTERVAL_MS) return previous;
  const seconds = Math.min(35 * 60,
    distanceKm / movementSpeed(history) * 3600 * 1.1 + Math.floor(distanceKm * 1000 / 800) * 20);
  const rawMinutes = seconds / 60;
  const smoothed = previous ? previous.minutes * 0.8 + rawMinutes * 0.2 : rawMinutes;
  // Keep the smoothed value, not the raw estimate. Bound visible changes even
  // when a GPS correction or turnaround substantially changes route distance.
  const gradualMinutes = previous
    ? Math.max(previous.minutes - 1, Math.min(previous.minutes + 1, smoothed))
    : smoothed;
  // Anchor the ceiling once per journey; repeated refreshes cannot raise it.
  const initialMinutes = previous?.initialMinutes ?? previous?.smoothedETA ?? Math.round(rawMinutes);
  const minutes = Math.min(gradualMinutes, initialMinutes + MAX_TOTAL_INCREASE_MINUTES);
  return { initialMinutes, minutes, smoothedETA: Math.round(minutes), etaSeconds: minutes * 60, updatedAt: now };
};
